export const directivePrefix = 'wp';
//# sourceMappingURL=constants.js.map